import { createSelector } from 'reselect';
import sortBy from 'lodash/sortBy';
import groupBy from 'lodash/groupBy';
import { formValueSelector } from 'redux-form';
import { LOCATION, SUBSIDIARY } from '../../../constants/constant_preference_types';




const getLocation = (state) => {
  if (state.listData.doctype) {
    return state.listData.doctype.location || [];
  }

  return [];
};

export const getLocations = createSelector(
  [getLocation],
  (locations) => {
    let list = [];

    if (!locations) return list;

    locations.forEach(location => {
      if (!location.is_sub_location) {
        list.push({ ...location })
      }
    });
    return list;
  }
);


const getPreferenceList = (state) => {
  return state.preference.list || [];
}

export const getGroupedPreferences = createSelector(
  [getPreferenceList],
  (preferences) => {
    let list = sortBy(preferences, 'label');
    list = sortBy(list, 'category');
    const groupedPreferences = groupBy(list, 'category');
    return groupedPreferences;
  }
);

function getLinePrefType(state, form) {
  const selector = formValueSelector(form);
  return selector(state, 'pref_type');
};

function getLineForm(state, field, form) {
  const selector = formValueSelector(form);
  return selector(state, field);
};

export const getPrefType = createSelector(
  [getLinePrefType],
  (prefType) => {
    return prefType;
  }
);

export const getLineSetting = createSelector(
  [getLineForm],
  (line) => {
    return line.setting;
  }
);


export const getLineSettingType = createSelector(
  [getLineForm],
  (line) => {
    return line.setting_type;
  }
);


export const getLineListType = createSelector(
  [getLineForm],
  (line) => {
    return line.list;
  }
);


export const getLineListFilter = createSelector(
  [getLineForm],
  (line) => {
    return line.filter||{};
  }
);


export const getDefinedList = createSelector(
  [getLineForm],
  (line) => {
    return line.defined_list||null;
  }
);


function getSelectedFilterPreferenceType(state, form) {
  const selector = formValueSelector(`PreferenceFilterForm_${form}`);
  return selector(state, 'pref_type');
}

function getSelectedFilterTypeId(state, form) {
  const selector = formValueSelector(`PreferenceFilterForm_${form}`);
  return selector(state, 'type_id');
}

export const showLocationFilter = createSelector(
  [getSelectedFilterPreferenceType],
  (preferenceType) => {
    return preferenceType === LOCATION;
  }
);

export const showSubsidiaryFilter = createSelector(
  [getSelectedFilterPreferenceType],
  (preferenceType) => {
    return preferenceType === SUBSIDIARY;
  }
);

function getPreferencesByCategory(state, category){
  return state.preference.list[category];
}

export const getSettingsByCategory = createSelector(
  [getPreferencesByCategory],
  (preferences) => {
    return preferences.map( preference => {
      return preference.setting;
    });
  }
);


export const showLocationColumn = createSelector(
  [
    getSelectedFilterPreferenceType,
    getSelectedFilterTypeId
  ],
  (preferenceType, typeId) => {
    return Boolean(preferenceType === LOCATION && typeId);
  }
);

export const showSubsidiaryColumn = createSelector(
  [
    getSelectedFilterPreferenceType,
    getSelectedFilterTypeId
  ],
  (preferenceType, typeId) => {
    return Boolean(preferenceType === SUBSIDIARY && typeId);
  }
);

function getEditMode(state, form){
  const selector = formValueSelector(form);
  return selector(state, 'editMode');
}


export const isViewMode = createSelector(
  [getEditMode],
  (editMode) => {
    return !editMode;
  }
);


function getIsLoading(state, form){
  const selector = formValueSelector(form);
  return selector(state, 'isLoading');
}


export const isLoading = createSelector(
  [getIsLoading],
  (isLoading) => {
    return isLoading;
  }
);


export const applyToLocation = createSelector(
  [getLineForm],
  (line) => {
    return line.applicable_to_location;
  }
);




export const applyToSubsidiary = createSelector(
  [getLineForm],
  (line) => {
    return line.applicable_to_subsidiary;
  }
);




export const applyToAccount = createSelector(
  [getLineForm],
  (line) => {
    return line.applicable_to_account;
  }
);